import { useContext, useCallback } from 'react';
import ForwardRefContext from 'src/contexts/ForwardRefContext';
import { useComparingConversationsParams } from '../compareModeHooks';

export const useMessageListRefActions = () => {
  const { mainMessageListRef, compareMessageListRef } =
    useContext(ForwardRefContext);

  const { secondComparedConvId } = useComparingConversationsParams();

  const getCurrentMessageListRef = useCallback(
    (conversationId?: string | null) => {
      if (!!secondComparedConvId && secondComparedConvId === conversationId) {
        return compareMessageListRef;
      }

      return mainMessageListRef;
    },
    [secondComparedConvId, mainMessageListRef, compareMessageListRef],
  );

  const resetMessageListRefCache = useCallback(() => {
    mainMessageListRef.current?.data.replace([]);
    compareMessageListRef.current?.data.replace([]);
  }, [mainMessageListRef, compareMessageListRef]);

  return { getCurrentMessageListRef, resetMessageListRefCache };
};
